<template>
  <div class="box">
    <img class="tp" src="../assets/images/TP.png" alt="">
    <div class="loginbox">
      <!--<div class="login">-->
        <!--<img src="../assets/images/com.png" alt="">-->
        <!--<input type="text" placeholder="输入企业名称">-->
      <!--</div>-->
      <div class="address">
        <p>+ {{$store.state.phoneCode}}</p>
        <router-link class="minbut" tag="span" to="/selectareacode">切换地区</router-link>
      </div>
      <div class="login">
        <img src="../assets/images/phone.png" alt="">
        <input v-model="$store.state.loginphone" type="number" placeholder="用户名称">
      </div>
      <div class="login">
        <img src="../assets/images/password.png" alt="">
        <input v-model="password" type="password" placeholder="输入密码">
      </div>
    </div>
    <div class="butbox">
      <div @click="submission" class="but">登入</div>
      <div class="other">
        <router-link tag="span" to="/forgetpassword">忘记密码</router-link>
        <router-link tag="span" to="/register">注册会员</router-link>
      </div>
    </div>
    <!--<router-link class="longo2" tag="div" to="/sellerlogin">卖家登录</router-link>-->
  </div>
</template>

<script>
    import Input from '../assembly/Input/Input'
    import { MessageBox } from 'mint-ui';
    import {getCode,login} from '../assets/js/api'
    export default {
        name: "login",
        components:{
          Input,
          MessageBox
        },
        data(){
          return {
            password:''
          }
        },
        mounted(){
          if (this.$store.state.phoneCode === ''){
            getCode().then((data)=>{
              this.$store.commit('set_phoneCode',data.map(itme=>itme.region_num)[0])
            })
          }
          if (localStorage.getItem('logindata') && localStorage.getItem('userdata')){
            this.$router.push({ path: '/index'});
          }
          // this.$router.push({ path: '/index'});
        },
        methods:{
          submission(){
            let state = true
            let message = ''
            if (this.$store.state.loginphone === ''){
              message='请填写手机号码'
              state = false
            }
            else if (this.password === ''){
              message='请填写密码'
              state = false
            }
            if (state) {
              login(this.$store.state.loginphone,this.$store.state.phoneCode,this.password).then(data=>{
                  MessageBox({
                    title: '提示',
                    showCancelButton: false,
                    message: data.message,
                    confirmButtonText:"确定",
                  }).then(res=>{
                    if (data.status) {
                      localStorage.setItem('logindata',JSON.stringify(data.data))
                      localStorage.setItem('userdata',JSON.stringify({
                        username:this.$store.state.loginphone,
                      }))
                      this.$router.push({ path: '/index'});
                    }
                  })
              })
            }
            else {
              MessageBox({
                title: '提示',
                showCancelButton: false,
                message: message,
                confirmButtonText:"确定",
              })
            }
          }
        }
    }
</script>

<style scoped lang="less">
.box{
  .tp{
    width: 100%;
  }
  .loginbox{
    width: 30%;
    margin: 20px auto;
    .address{
      display: flex;
      align-items: center;
      height: 26px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e8e8e8;
      position: relative;
      margin: 20px 0;
      p{
        font-size: 0.3rem;
        width: 100%;
        padding-left: 0;
      }
      .minbut{
        display: block;
        padding: 5px 10px;
        position: absolute;
        border: 1px solid #979797;
        border-radius: 23px;
        right: 0;
        top: 0;
      }
    }
    .login{
      display: flex;
      justify-content: space-around;
      margin: 40px auto;
      position: relative;
      img{
        /*padding-bottom: 10px;*/
        width: 26px;
        height: 32px;
      }
      input{
        border: none;
        font-size: 0.3rem;
        border-bottom: 1px solid #979797;
        width: 80%;
        /*margin-left: 10%;*/
        &:focus{
          border-color: #22bb61;
        }
        &::placeholder{
          color: #7c7c7c;
        }
      }
    }
  }
  .butbox{
    width: 30%;
    margin: 0 auto;
    .but{
      text-align: center;
      padding: 16px 0;
      background-color: #979797;
      color: #353535;
      border-radius: 5px;
      margin-bottom: 20px;
    }
    .other{
      display: flex;
      justify-content: space-between;
    }
  }
  .longo2{
    width: 20%;
    margin: 20px auto;
    text-align: center;
    padding: 16px 0;
    background-color: #979797;
    color: #353535;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue